import React from "react";

import LazyHydrate from "@components/utils/LazyHydrate";
import CalendlyWidget from "@components/molecules/CalendlyWidget";

import { CalendlyWidgetStoryblokProps } from "./types";

const CalendlyWidgetStoryblok: React.FC<
  CalendlyWidgetStoryblokProps
> = ({ blok }) => {
  const { url } = blok;

  return (
    <LazyHydrate
      useDisplayContents={false}
      noWrapper
      whenVisible
      getEventTarget={() => window}
    >
      <CalendlyWidget {...{ url }} />
    </LazyHydrate>
  );
};

export default CalendlyWidgetStoryblok;
